import Tool from './tool';
import Toast from './toast';
import Constant from './constant';
import Array from './array';
import Json from './json';
import Form from './form';
import Table from './table';
import Pattern from './pattern';
import Storage from './storage';
import Excel from './excel';
var Utils = {
  Tool: Tool,
  Toast: Toast,
  Constant: Constant,
  Array: Array,
  Json: Json,
  Form: Form,
  Table: Table,
  Pattern: Pattern,
  Storage: Storage,
  Excel: Excel
};
export default Utils;